export var RANGE_VALUE = 'range';
export var RANGE_TYPE = 'type';
export var PERCENT = 'percent';
export var DEFAULT_COLOR = '#f0f0f0';
//# sourceMappingURL=constant.js.map